export const FETCH_SUBSCRIPTIONWAREHOUSE_ACTION =
  "FETCH_SUBSCRIPTIONWAREHOUSE_ACTION";
export const FETCH_SUBSCRIPTIONWAREHOUSE_FAIL_ACTION =
  FETCH_SUBSCRIPTIONWAREHOUSE_ACTION + "_ERROR";
export const FETCH_SUBSCRIPTIONWAREHOUSE_SUCCESS_ACTION =
  FETCH_SUBSCRIPTIONWAREHOUSE_ACTION + "_SUCCESS";

export const CREATE_REQUESTWAREHOUSESUBSCRPTN_INIT_ACTION =
  "CREATE_REQUESTWAREHOUSESUBSCRPTN_INIT_ACTION";
export const CREATE_REQUESTWAREHOUSESUBSCRPTN_SUCCESS_ACTION =
  CREATE_REQUESTWAREHOUSESUBSCRPTN_INIT_ACTION + "_SUCCESS";
export const CREATE_REQUESTWAREHOUSESUBSCRPTN_FAIL_ACTION =
  CREATE_REQUESTWAREHOUSESUBSCRPTN_INIT_ACTION + "_ERROR";

export const CREATE_INVOICE_ACTION = "CREATE_INVOICE_ACTION";
export const CREATE_INVOICE_FAIL_ACTION = CREATE_INVOICE_ACTION + "_ERROR";
export const CREATE_INVOICE_SUCCESS_ACTION = CREATE_INVOICE_ACTION + "_SUCCESS";

export const CREATE_PAYMENT_ACTION = "CREATE_PAYMENT_ACTION";
export const CREATE_PAYMENT_FAIL_ACTION = CREATE_PAYMENT_ACTION + "_ERROR";
export const CREATE_PAYMENT_SUCCESS_ACTION = CREATE_PAYMENT_ACTION + "_SUCCESS";


export const CREATE_CANCELWAREHOUSESUBSCRPTN_INIT_ACTION =
"CREATE_CANCELWAREHOUSESUBSCRPTN_INIT_ACTION";
export const CREATE_CANCELWAREHOUSESUBSCRPTN_SUCCESS_ACTION =
CREATE_CANCELWAREHOUSESUBSCRPTN_INIT_ACTION + "_SUCCESS";
export const CREATE_CANCELWAREHOUSESUBSCRPTN_FAIL_ACTION =
CREATE_CANCELWAREHOUSESUBSCRPTN_INIT_ACTION + "_ERROR";


export const FETCH_HISTORYSUBSCRIPTIONWAREHOUSE_ACTION =
  "FETCH_HISTORYSUBSCRIPTIONWAREHOUSE_ACTION";
export const FETCH_HISTORYSUBSCRIPTIONWAREHOUSE_FAIL_ACTION =
  FETCH_HISTORYSUBSCRIPTIONWAREHOUSE_ACTION + "_ERROR";
export const FETCH_HISTORYSUBSCRIPTIONWAREHOUSE_SUCCESS_ACTION =
  FETCH_HISTORYSUBSCRIPTIONWAREHOUSE_ACTION + "_SUCCESS";
